export type MediaQuery = {
  not?: boolean
  all?: boolean
  print?: boolean
  screen?: boolean
  speech?: boolean
  anyHover?: 'none' | 'hover'
  anyPointer?: 'none' | 'coarse' | 'fine'
  aspectRatio?: string
  color?: number
  minColor?: number
  maxColor?: number
  colorGamut?: 'srgb' | 'p3' | 'rec2020'
  colorIndex?: number
  minColorIndex?: number
  maxColorIndex?: number
  displayMode?: 'fullscreen' | 'standalone' | 'minimal-ui' | 'browser'
  forcedColors?: 'none' | 'active'
  grid?: boolean
  height?: number
  minHeight?: number
  maxHeight?: number
  hover?: 'none' | 'hover'
  invertedColors?: 'none' | 'inverted'
  lightLevel?: 'dim' | 'normal' | 'washed'
  monochrome?: number
  minMonochrome?: number
  maxMonochrome?: number
  orientation?: 'portrait' | 'landscape'
  overflowBlock?: 'none' | 'scroll' | 'optional-paged' | 'paged'
  overflowInline?: 'none' | 'scroll'
  pointer?: 'none' | 'coarse' | 'fine'
  prefersColorScheme?: 'no-preference' | 'light' | 'dark'
  prefersContrast?: 'no-preference' | 'high' | 'low'
  prefersReducedMotion?: 'no-preference' | 'reduce'
  prefersReducedTransparency?: 'no-preference' | 'reduce'
  resolution?: number
  minResolution?: number
  maxResolution?: number
  scripting?: 'none' | 'initial-only' | 'enabled'
  width?: number
  minWidth?: number
  maxWidth?: number
}

export const getMediaQuerySelector = (mediaQuery: MediaQuery) =>
  Object.entries(mediaQuery)
    .map(([key, value]) => {
      const hyphenatedKey = key.replace(/(.)([A-Z])/, (_, g1, g2) =>
        g1 ? `${g1}-${g2.toLowerCase()}` : `${g2.toLowerCase()}`,
      )
      switch (key) {
        case 'not':
        case 'all':
        case 'print':
        case 'screen':
        case 'speech':
          return key

        case 'grid':
          return `(${hyphenatedKey}: ${value ? '1' : '0'})`

        case 'width':
        case 'minWidth':
        case 'maxWidth':
        case 'height':
        case 'minHeight':
        case 'maxHeight':
          return `(${hyphenatedKey}: ${value}px)`

        default:
          return `(${hyphenatedKey}: ${value})`
      }
    })
    .join(' and ')

export const deviceMediaQueries = {
  tablet: { minWidth: 670 } as MediaQuery,
  desktop: { minWidth: 1200 } as MediaQuery,
}

export type DeviceSize = keyof typeof deviceMediaQueries

export const getDeviceSizeSelector = (device: DeviceSize) =>
  getMediaQuerySelector(deviceMediaQueries[device])
